import React, { useState, useEffect } from "react";
import HomePageGrid from "./HomePageGrid";
import HomePageForm from "./HomePageForm";
import ConfirmDialog from "../../../utils/ConfirmDialog"; 

const EditHomePage = () => {
  const [data, setData] = useState([]);
  const [view, setView] = useState("grid");
  const [messages, setMessages] = useState({ heading: "", para: "", id: null });
  const [editingId, setEditingId] = useState(null);
  const [deleteId, setDeleteId] = useState(null);

  const showData = () => {
    fetch("https://kvrstarlightmedicalacademy.com/api/home.php")
      .then((response) => response.json())
      .then((data) => setData(data));
  };

  useEffect(() => {
    showData();
  }, []);

  const handleCreate = () => {
    setMessages({ heading: "", para: "", id: null });
    setEditingId(null);
    setView("form");
  };

  const handleEdit = (id) => {
    const selected = data.find((item) => item.id === id);
    if (selected) {
      setMessages(selected);
      setEditingId(id);
      setView("form");
    }
  };

  const handleDelete = (id) => {
    setDeleteId(id);
  };

  const confirmDelete = async () => {
    try {
      const res = await fetch("https://kvrstarlightmedicalacademy.com/api/home.php", {
        method: "DELETE",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id: deleteId }),
      });

      if (res.ok) {
        console.log("Deleted successfully");
      } else {
        console.error("Server error:", res.status);
      }
    } catch (err) {
      console.error("Fetch error:", err);
    }
    setDeleteId(null);
    showData();
  };

  const cancelDelete = () => {
    setDeleteId(null);
  };

  const handleFormSubmit = async (message) => {
    const method = editingId ? "PUT" : "POST";

    try {
      const res = await fetch("https://kvrstarlightmedicalacademy.com/api/home.php", {
        method,
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(message),
      });

      if (res.ok) {
        const result = await res.json();
        console.log("Server response:", result);
      } else {
        console.error("Server error:", res.status);
      }
    } catch (err) {
      console.error("Fetch error:", err);
    }

    setMessages({ heading: "", para: "", id: null });
    setView("grid");
    showData();
  };

  return (
    <div className="container mt-4">
      {view === "grid" ? (
        <HomePageGrid
          data={data}
          onCreate={handleCreate}
          onEdit={handleEdit}
          onDelete={handleDelete}
        />
      ) : (
        <HomePageForm
          onSubmit={handleFormSubmit}
          onCancel={() => setView("grid")}
          initialData={messages}
        />
      )}

      {deleteId !== null && (
        <ConfirmDialog
          message="Are you sure you want to delete this item?"
          onConfirm={confirmDelete}
          onCancel={cancelDelete}
        />
      )}
    </div>
  );
};

export default EditHomePage;
